import { render, staticRenderFns } from "./verticalSide.vue?vue&type=template&id=2ccf765c&"
import script from "./verticalSide.vue?vue&type=script&lang=js&"
export * from "./verticalSide.vue?vue&type=script&lang=js&"
import style0 from "./verticalSide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports